<div class="keyboard">
    <button mat-raised-button class="teclas-numeros" *ngFor="let key of ['1','2','3','4','5','6','7','8','9','0','.','C']"
            (click)="sendInput(key)">
      {{ key }}
    </button>
  </div>